module.exports = __webpack_public_path__ + "img/by.d1de75d7.png";